/// Uygulama (giriş + giriş sonrası) rota önekleri — scripts/site/app-routes.mjs
/// ile AYNI liste (check-app-routes testi zorlar). Bunların dışındaki her yol
/// herkese açık sitedir: kabuk ve KVKK kapısı yok, public layout çizilir,
/// bilinmeyen yol 404 sayfası. nginx de aynı listeyle karar verir; böylece
/// prerender HTML'i ile istemcinin ilk render'ı aynı dalı seçer (hydration).
export const APP_ROUTE_PREFIXES: readonly string[] = [
  'auth',
  'support/tickets',
  'dashboard',
  'gyms',
  'users',
  'trainers',
  'students',
  'lessons',
  'packages',
  'payments',
  'reports',
  'my-reports',
  'cafe',
  'settings',
  'profile',
  'api-tokens',
  'oauth',
  'notifications',
  'announcements',
  'admin',
  'error',
];

function pathOf(url: string): string {
  return url.split(/[?#]/)[0] || '/';
}

export function isAppRoute(url: string): boolean {
  const path = pathOf(url);
  return APP_ROUTE_PREFIXES.some((p) => path === `/${p}` || path.startsWith(`/${p}/`));
}

/// Herkese açık site (public layout): uygulama öneki olmayan her yol. Bilinmeyen yolda
/// nginx prerender 404'ünü verir, istemci de aynı dalı seçer (hidrasyon). Geliştirme
/// vitrini (/dev/ui-kit) Faz 5'te kalktı; /dev/* artık her ortamda sıradan site yoludur.
export function isSiteRoute(url: string): boolean {
  return !isAppRoute(url);
}

/// Kabuk (sidebar/topbar) ve KVKK kapısı olmadan açılan yollar: site + /auth.
/// Kapı bunlarda çıkmaz: kullanıcı onayladığı aydınlatma metnini okuyabilmeli.
export function isPublicRoute(url: string): boolean {
  const path = pathOf(url);
  return isSiteRoute(url) || path === '/auth' || path.startsWith('/auth/');
}
